import { render, staticRenderFns } from "./combo-planos.vue?vue&type=template&id=0295521e"
import script from "./combo-planos.vue?vue&type=script&lang=ts"
export * from "./combo-planos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports